module.exports = __webpack_public_path__ + "media/about-video.bec152a5.webm";